import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCampaigns = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.9231 3H2.07692C1.92391 3 1.77717 3.06321 1.66898 3.17574C1.56078 3.28826 1.5 3.44087 1.5 3.6V13.8C1.5 14.1183 1.62157 14.4235 1.83795 14.6485C2.05434 14.8736 2.34783 15 2.65385 15H15.3462C15.6522 15 15.9457 14.8736 16.162 14.6485C16.3784 14.4235 16.5 14.1183 16.5 13.8V3.6C16.5 3.44087 16.4392 3.28826 16.331 3.17574C16.2228 3.06321 16.0761 3 15.9231 3ZM9.8726 8.55L9 9.3825L3.5625 4.2H14.4375L9.8726 8.55ZM6.88702 9L2.65385 13.035V4.965L6.88702 9ZM7.73798 9.8175L8.61058 10.6425C8.71693 10.7437 8.85585 10.7998 9 10.7998C9.14415 10.7998 9.28307 10.7437 9.38942 10.6425L10.262 9.8175L14.4375 13.8H3.5625L7.73798 9.8175ZM11.113 9L15.3462 4.965V13.035L11.113 9Z",
		fill: "white",
		fillOpacity: .74
	})]
});
const ForwardRef = forwardRef(SvgCampaigns);
export { ForwardRef as ReactComponent };
